import React, { useCallback, useMemo, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import localPDF from "./Catalog_2025.pdf";
import "./AmwayDoc.css"; // ← ใช้สไตล์จากไฟล์แยก

pdfjs.GlobalWorkerOptions.workerSrc =
  `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function escapeRegExp(s = "") {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export default function AmwayDocView({
  fileUrl,                 // ไม่ส่ง = ใช้ local PDF
  initialScale = 1.1,
  viewerHeight = "75vh",   // ควบคุมความสูงของกรอบแสดงผล
}) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [query, setQuery] = useState("");
  const [submitted, setSubmitted] = useState("");
  const [pageHasText, setPageHasText] = useState(true);
  const [noHit, setNoHit] = useState(false);

  const fileToOpen = fileUrl || localPDF;

  const onDocLoad = useCallback(({ numPages }) => setNumPages(numPages), []);

  const queryRegex = useMemo(() => {
    if (!submitted) return null;
    try {
      return new RegExp(escapeRegExp(submitted), "gi");
    } catch {
      return null;
    }
  }, [submitted]);

  // ไฮไลต์คำที่เจอ
  const customTextRenderer = useCallback(
    (textItem) => {
      const str = textItem.str || "";
      if (!queryRegex) return str;
      return str.replace(queryRegex, (m) => `<span class="highlight">${m}</span>`);
    },
    [queryRegex]
  );

  // เช็คว่าหน้านี้มีข้อความจริงไหม
  const handleGetTextSuccess = (result) => {
    const items = Array.isArray(result) ? result : result?.items;
    setPageHasText((items?.length || 0) > 0);
  };

  // ค้นหา “หน้าถัดไป” ที่มีคำ (วนทั้งเล่ม)
  const jumpToNextHit = async (q) => {
    if (!q || !numPages) return;
    setNoHit(false);

    try {
      const task = pdfjs.getDocument(fileToOpen);
      const pdf = await task.promise;
      const total = pdf.numPages;
      const start = pageNumber >= total ? 1 : pageNumber + 1;

      const scanRange = async (a, b) => {
        for (let i = a; i <= b; i++) {
          const page = await pdf.getPage(i);
          const text = await page.getTextContent();
          const plain = text.items.map((it) => it.str || "").join(" ");
          if (plain.toLowerCase().includes(q.toLowerCase())) {
            setPageNumber(i);
            return true;
          }
        }
        return false;
      };

      if (await scanRange(start, total)) return;
      if (await scanRange(1, pageNumber)) return;

      setNoHit(true);
    } catch (err) {
      console.error("jumpToNextHit error:", err);
      setNoHit(true);
    }
  };

  const onSubmitSearch = async (e) => {
    e.preventDefault();
    const q = query.trim();
    setSubmitted(q);        // ให้ไฮไลต์ในหน้าปัจจุบัน
    await jumpToNextHit(q); // แล้วกระโดดไปหน้าถัดไปที่พบ
  };

  return (
    <div className="amway-page">
      {/* แถบค้นหา */}
      <form onSubmit={onSubmitSearch} className="amway-searchBar">
        <input
          type="text"
          placeholder="ใส่คำค้นหา"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="amway-input"
        />
        <button type="submit" className="amway-button">ค้นหา</button>
      </form>

      {/* ปุ่มเปลี่ยนหน้า */}
      <div className="amway-toolbar">
        <button
          type="button"
          onClick={() => setPageNumber((p) => Math.max(1, p - 1))}
          disabled={pageNumber <= 1}
          className="amway-toolBtn"
        >
          ← ก่อนหน้า
        </button>

        <span className="amway-pageInfo">
          หน้า {pageNumber} / {numPages || "-"}
        </span>

        <button
          type="button"
          onClick={() =>
            setPageNumber((p) => (numPages ? Math.min(numPages, p + 1) : p))
          }
          disabled={!numPages || pageNumber >= numPages}
          className="amway-toolBtn"
        >
          ถัดไป →
        </button>
      </div>

      {/* Viewer (ชิดบน + ครอปบน ทำในไฟล์ CSS) */}
      <div className="pdf-cropper amway-viewer" style={{ height: viewerHeight }}>
        <Document
          file={fileToOpen}
          onLoadSuccess={onDocLoad}
          loading={<div className="amway-loading">กำลังโหลดเอกสาร…</div>}
        >
          <Page
            pageNumber={pageNumber}
            scale={initialScale}
            renderTextLayer
            renderAnnotationLayer={false}
            customTextRenderer={customTextRenderer}
            onGetTextSuccess={handleGetTextSuccess}
          />
        </Document>
      </div>

      {/* แจ้งเตือน */}
      {!pageHasText && (
        <div className="amway-note">
          หน้านี้เป็นภาพสแกน ไม่มีตัวอักษรให้ค้นหา/ไฮไลต์ (ต้องทำ OCR ก่อน)
        </div>
      )}
      {noHit && submitted && (
        <div className="amway-note">ไม่พบ “{submitted}” ในทั้งเอกสาร</div>
      )}
    </div>
  );
}
